import * as React from "react";
import type { SVGProps } from "react";
const SvgEmptyFilters = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={53}
    height={45}
    fill="none"
    viewBox="0 0 53 45" {...props}
  >
    <path
      fill="url(#empty-filters_svg__a)"
      d="M.28 15.522c1.786 3.555 5.34 10.107 10.347 16.628 2.822 3.683 5.675 6.52 8.13 8.61a44 44 0 0 0 4.002 3.044 6.06 6.06 0 0 0 5.772.542l20.263-8.752a1.5 1.5 0 0 0 .35-.192c1.085-.733 1.18-2.375.08-3.22-3.172-2.44-8.545-6.935-13.344-12.77-.016-.032-.047-.048-.063-.08-.208-.24-.399-.494-.606-.733-4.528-5.549-7.637-9.965-9.279-12.372a3.154 3.154 0 0 0-3.635-1.228l-4.432 1.483-9.088 3.045-6.982 2.328A2.625 2.625 0 0 0 .28 15.52"
      opacity={0.6}
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.319}
      d="M2.449 11.473c1.754 3.571 5.261 10.155 10.188 16.724 2.79 3.715 5.611 6.568 8.067 8.673a52 52 0 0 0 3.97 3.077 6.02 6.02 0 0 0 5.77.59l20.344-8.562a1.5 1.5 0 0 0 .35-.191c1.085-.733 1.196-2.36.112-3.204-3.14-2.472-8.481-7.015-13.233-12.898-.015-.032-.047-.064-.063-.08-.208-.24-.399-.494-.59-.733C32.9 9.273 29.807 4.84 28.197 2.417a3.16 3.16 0 0 0-3.62-1.26L20.13 2.594l-9.12 2.965-6.999 2.264a2.628 2.628 0 0 0-1.546 3.65z"
    />
    <path
      stroke="#A4ADBE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.6}
      d="M8.411 22.107s-8.625 5.707-1.913 13.025c5.74 6.25 16.326 2.599 26.067-10.251C40.807 13.99 50.118 4.809 50.118 4.809"
    />
    <path
      stroke="#A4ADBE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.6}
      d="m46.8 5.685 3.38-1.037-.254 3.205"
    />
    <path
      fill="#FFCE00"
      d="m31.226 24.976 1.77 1.1c.35.224.813.224 1.164 0l.988-.621c.335-.208.558-.542.606-.925l.175-1.132a1.04 1.04 0 0 0-.478-1.036l-1.961-1.228a.81.81 0 0 0-.829-.032l-1.291.686a.89.89 0 0 0-.495.75l-.127 1.53a1 1 0 0 0 .462.924z"
    />
    <path
      fill="#07105F"
      d="M4.935 34.478a1.562 1.562 0 1 0 0-3.124 1.562 1.562 0 0 0 0 3.124"
    />
    <path
      fill="url(#empty-filters_svg__b)"
      d="m26.309 10.212-13.643 5.1-1.62-2.613L24.69 7.853z"
      opacity={0.6}
    />
    <path
      fill="url(#empty-filters_svg__c)"
      d="M27.413 14.58 16.92 18.723 15.3 16.11l10.494-3.89z"
      opacity={0.6}
    />
    <path
      fill="url(#empty-filters_svg__d)"
      d="m27.923 18.658-7.177 3.124-1.365-2.359 7.178-2.868z"
      opacity={0.6}
    />
    <defs>
      <linearGradient
        id="empty-filters_svg__a"
        x1={0.075}
        x2={49.894}
        y1={25.054}
        y2={24.619}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
      <linearGradient
        id="empty-filters_svg__b"
        x1={11.07}
        x2={26.273}
        y1={11.624}
        y2={11.407}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
      <linearGradient
        id="empty-filters_svg__c"
        x1={15.319}
        x2={27.385}
        y1={15.508}
        y2={15.351}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
      <linearGradient
        id="empty-filters_svg__d"
        x1={19.394}
        x2={27.904}
        y1={19.197}
        y2={19.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgEmptyFilters;
